var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHashtag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-19bff9ec-ee42-4908-a6a3-5167fc5cd45a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-5dc5a9f7-41b6-443a-82f0-6664c1dca170 {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-5dc5a9f7-41b6-443a-82f0-6664c1dca170",
    d: "M20.52,17.06h-1.71l.38-2.11h1.33c.55,0,1-.45,1-1s-.45-1-1-1h-.97l.23-1.28c.1-.54-.26-1.06-.81-1.16-.55-.1-1.06.26-1.16.81l-.3,1.64h-2.07l.46-2.61c.1-.54-.27-1.06-.81-1.16-.55-.1-1.06.27-1.16.81l-.53,2.96h-1.93c-.55,0-1,.45-1,1s.45,1,1,1h1.58l-.38,2.11h-1.2c-.55,0-1,.45-1,1s.45,1,1,1h.85l-.46,2.61c-.1.54.27,1.06.81,1.16.06.01.12.02.18.02.48,0,.9-.34.98-.83l.53-2.96h2.05l-.23,1.28c-.1.54.26,1.06.81,1.16.06.01.12.02.18.02.47,0,.9-.34.98-.82l.3-1.64h2.07c.55,0,1-.45,1-1s-.45-1-1-1ZM14.72,17.06l.38-2.11h2.06l-.38,2.11h-2.06Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtag);
export default __webpack_public_path__ + "static/media/Hashtag.705adc3c399cd04c99ac61a0946fd694.svg";
export { ForwardRef as ReactComponent };